import { AuthState, ITAP_BOT_EMAIL, ITAP_USER_EMAIL, JobState, State } from "../types";

export interface ClearActiveJobAction {
  type: "CLEAR ACTIVE JOB";
}
export const clearActiveJob = (state: State, _: ClearActiveJobAction): State => {
  if (state.job.state === JobState.initial && state.sidebarVisible === true) {
    return state;
  }
  return {
    ...state,
    job: {
      state: JobState.initial,
    },
    activeJobId:undefined,
    sidebarVisible: state.auth.state === AuthState.loggedIn && (state.auth.user.email === ITAP_USER_EMAIL || state.auth.user.email.endsWith(ITAP_BOT_EMAIL))? false : true,
  };
};
